module.exports = __webpack_public_path__ + "static/media/tell_us.f82cf20f.webp";